document.addEventListener('easysearch_loaded', function (e) {
	var easysearch_container = $('#easysearch-container');
    if(easysearch_container.length) {
      var selects = easysearch_container.find('select');
      checkSelectors(selects);
      if(selects.length){
        $.each(selects, function(i, v) {
          $(v).on('change', function(){checkSelectors(selects);});
        });
      }
    }
  	
  	function checkSelectors(selects) {
      setTimeout(function() {
        $.each(selects, function(i, v) {
          if(!$(v).prop('disabled')) {
            if($(v).val().length) {
              $(v).parent().addClass('is_checked');
              $(v).removeClass('is_mark');
            } else {
              $(v).addClass('is_mark');
              $(v).parent().removeClass('is_checked');
            }
          } else {
          	$(v).removeClass('is_mark');
            $(v).parent().removeClass('is_checked');
          }
        });
      	var Indexes = easysearch.curIndex.split(",");
      }, 1000);
	}
});

/* iTEKcanada 2026-10-18: product-only compatibility tab mobile accessibility; reversible. */
(function () {
  'use strict';
  var cssId = 'itek-compat-mobile-fix-20261018';
  function repairCompatibilityAnchor() {
    if (!document.body || !document.body.classList.contains('templateProduct')) return;
    if (!document.querySelector('a[href="#itek-compatibility"]')) return;
    if (!document.getElementById(cssId)) {
      var style = document.createElement('style');
      style.id = cssId;
      style.textContent = '@media (max-width:767px){body.templateProduct #tabs-2:has(a[href="#itek-compatibility"]){display:flow-root!important;position:relative!important;z-index:101!important;}}';
      document.head.appendChild(style);
    }
    if (!document.getElementById('itek-compatibility')) {
      var panel = document.querySelector('body.templateProduct #tabs-4');
      if (panel) {
        var marker = document.createElement('span');
        marker.id = 'itek-compatibility';
        marker.setAttribute('aria-hidden', 'true');
        marker.style.cssText = 'display:block;position:relative;scroll-margin-top:90px;';
        panel.insertBefore(marker, panel.firstChild);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repairCompatibilityAnchor);
  } else {
    repairCompatibilityAnchor();
  }
  window.addEventListener('load', repairCompatibilityAnchor);
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest && event.target.closest('a[href="#itek-compatibility"]');
    if (!link) return;
    repairCompatibilityAnchor();
    window.setTimeout(function () {
      var target = document.getElementById('itek-compatibility');
      if (target) target.scrollIntoView({behavior:'smooth',block:'start'});
    }, 50);
  }, false);
}());